import React from 'react'
import { cx } from '@/lib/utils'
import { useInView } from '@/hooks/useInView'
import styles from './Section.module.scss'

type Padding = 'sm' | 'md' | 'lg' | 'xl'
type Background = 'base' | 'alt'

interface SectionProps {
  children: React.ReactNode
  padding?: Padding
  background?: Background
  id?: string
}

const paddingMap: Record<Padding, string> = {
  sm: styles.paddingSm,
  md: styles.paddingMd,
  lg: styles.paddingLg,
  xl: styles.paddingXl,
}

const bgMap: Record<Background, string> = {
  base: styles.bgBase,
  alt: styles.bgAlt,
}

export const Section: React.FC<SectionProps> = ({
  children, padding = 'lg', background = 'base', id,
}) => {
  const { ref, inView } = useInView<HTMLElement>()

  return (
    <section
      ref={ref}
      id={id}
      className={cx(styles.section, paddingMap[padding], bgMap[background], styles.reveal, inView && styles.visible)}
    >
      {children}
    </section>
  )
}
